



































































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import moment from 'moment';
import AffiliateService from '@/services/AffiliateService';

const affiliateService = new AffiliateService();

@Component
export default class RefundLossDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public loading: boolean = false;

  public isAlreadyRedeem: boolean = false;

  public share: any = {};

  public fetchError: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  get previousWeek() {
    return String(
      moment().startOf('week').subtract(1, 'week').week(),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  get currentYear() {
    return '2026';
  }

  // eslint-disable-next-line class-methods-use-this
  get weekRange() {
    const previousWeek = moment().startOf('week').subtract(1, 'week');
    return `${previousWeek.startOf('week').format('YYYY-MM-DD')},${previousWeek.endOf('week').format('YYYY-MM-DD')}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get isAvailableToRedeem() {
    const today = moment().format('YYYY-MM-DD');
    const dayToRedeem = moment().startOf('week').format('YYYY-MM-DD');
    return today === dayToRedeem;
  }

  async claimShare() {
    try {
      this.loading = true;
      // eslint-disable-next-line no-underscore-dangle
      const { data } = await affiliateService.cliamShare(this.share._id);
      this.share = { ...data };
      this.$store.commit('Snackbar/showNotification', { message: 'ถอนเงินสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.loading = false;
  }

  async created() {
    try {
      const { data } = await affiliateService.getShare(`${this.previousWeek}-${this.currentYear}`);
      console.log(data);
      if (data) {
        this.isAlreadyRedeem = data.is_paid;
        this.share = { ...data };
      } else {
        this.fetchError = true;
      }
    } catch (e) {
      this.fetchError = true;
    }
  }
}
